var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle213(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "290.26 55.55824752745496 19.49472402027226 19.384642503215694",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M305.74,65.55c-.14,3.21-2.85,5.59-6.14,5.38-3-.19-5.34-2.65-5.34-5.62,0-3.16,2.72-5.83,5.87-5.75,3.18.08,5.75,2.82,5.62,5.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle213);
export default __webpack_public_path__ + "static/media/twinkle-2-13.4d40ac46abae982314de9858c6f5ae75.svg";
export { ForwardRef as ReactComponent };